import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TaskClosedIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="taskClosed" ref={ref} {...props}>
      <path d="M12,1.25A10.75,10.75,0,1,0,19.49,19.7l.05,0,.06-.06a.52.52,0,0,0,.1-.11A10.74,10.74,0,0,0,12,1.25Zm0,1.5A9.26,9.26,0,0,1,21.25,12,9.16,9.16,0,0,1,19,18l-3.51-3.51a.61.61,0,0,0,0-.14c0-2.25-2.19-2.86-3.24-3.15l-.08,0-2-2a2.24,2.24,0,0,1,1.91-1A2.59,2.59,0,0,1,14.21,9a.75.75,0,0,0,1.06,0,.75.75,0,0,0,0-1.06A4.06,4.06,0,0,0,12.1,6.68,3.76,3.76,0,0,0,9.1,8L6,5A9.25,9.25,0,0,1,12,2.75Zm0,18.5A9.25,9.25,0,0,1,5,6L8.58,9.64h0c0,1.94,1.75,2.54,2.86,2.86h0L13.9,15A2.11,2.11,0,0,1,12,16a3.24,3.24,0,0,1-2.35-.77.75.75,0,0,0-1.18.92A4.53,4.53,0,0,0,12,17.45a3.73,3.73,0,0,0,3-1.39l3,3A9.17,9.17,0,0,1,12,21.25Zm7.6-1.65h0l-.06.05Z" />
    </Icon>
  ),
) as IconWithRender;

TaskClosedIcon.displayName = 'TaskClosedIcon';
TaskClosedIcon.renderIcon = (props) => <TaskClosedIcon {...props} />;
export default TaskClosedIcon;
